<template>
  <div :id="id" class="tw-flex tw-items-center">
    <div class="tw-flex tw-flex-row tw-items-center">
      <SearchIcon :size="15" color="#B7B7B7" :svg-class="iconSearchStyle" />
    </div>
    <div class="tw-flex tw-justify-around tw-items-center tw-w-full">
      <BFormInput
        :id="inputSearch"
        v-model="currentValue"
        type="text"
        :placeholder="placeholder"
        class="input-search tw-border-none tw-outline-none tw-ml-[9px] !tw-p-0 tw-text-[14px] tw-text-[#211f58]"
        :class="inputStyle"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
      />
      <button
        v-if="currentValue !== ''"
        type="button"
        class="tw-bg-transparent tw-border-none tw-outline-none"
        @click="clearData"
      >
        <CloseBoxIcon :size="15" color="#DBDBDB" :svg-class="iconCloseStyle" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import SearchIcon from "@/components/svgs/searchIcon.vue";
import { ref, watch } from "vue";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import { getComponentUiText } from "@/utils/utilities";

const emit = defineEmits(["update:modelValue", "on:focus", "on:blur"]);

const props = defineProps({
  /** The model and value of the input */
  modelValue: { type: null, required: true },
  inputStyle: { type: String, required: false, default: "" },
  iconSearchStyle: { type: String, required: false, default: "" },
  iconCloseStyle: { type: String, required: false, default: "" },
  placeholder: {
    type: String,
    required: false,
    default: getComponentUiText("app-header-search-prompt-1"),
  },
  inputSearch: { type: String, required: false, default: "" },
  id: { type: String, required: false, default: "" },
});

let currentValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    currentValue = ref(props.modelValue);
  },
);

const handleInput = (val: string) => {
  emit("update:modelValue", currentValue.value);
};

const handleFocus = () => {
  emit("on:focus");
};

const handleBlur = () => {
  emit("on:blur");
};

const clearData = () => {
  currentValue.value = "";
  emit("update:modelValue", currentValue.value);
};
</script>

<style lang="scss" scoped>
.input-search {
  &::placeholder {
    color: var(--UI-light-grey, #b7b7b7);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}

.form-control {
  &:focus {
    border: none !important;
    box-shadow: none !important;
  }
}
</style>
